import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowUpRight"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00019 5H19.0002V16H16.5002V9.26777L6.25019 19.5178L4.48242 17.75L14.7324 7.5H8.00019V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpRight;
